import { useMemo } from 'react';
import { ComponentType } from '@vgtv/api-client/lib/component';

import { CategoryThumbnail } from '../../../Category/CategoryThumbnail';
import { getCategoryMainImage } from '../../../../shared/helpers/categoryHelpers';
import { getImageSources } from '../../../../helpers/images';

import type { FC } from 'react';
import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';
import type { MixedSliderComponent } from '@vgtv/api-client/lib/component/slider';
import type { MixedListComponent } from '@vgtv/api-client/lib/component/list';
import type { ImageSize } from '../../../../helpers/images';
import type { ImagePreset } from '../../../../helpers/images/presets';

type Component = MixedSliderComponent | MixedListComponent;

interface CategoryProps {
  category: SvpCategoryAdditional;
  componentType: Component['type'];
  onClick?: () => void;
  skipMetadata?: boolean;
  size?: ImageSize;
  onHover?: () => void;
  replacePath?: boolean;
}

const getImagePreset = (componentType: Component['type']): ImagePreset => {
  switch (componentType) {
    case ComponentType.SLIDER:
      return 'categoriesSlider';
    case ComponentType.LIST:
      return 'categoriesList';
  }
};

export const CategoryItem: FC<CategoryProps> = ({
  category,
  componentType,
  onClick,
  skipMetadata = false,
  size,
  onHover,
  replacePath,
}) => {
  const { title } = category;
  const description = category.additional?.description || undefined;

  const imageSources = useMemo(
    () =>
      getImageSources({
        imageUrl: getCategoryMainImage(category),
        imagePreset: getImagePreset(componentType),
        size,
      }),
    [category, componentType, size]
  );

  return (
    <CategoryThumbnail
      category={category}
      title={title}
      description={description}
      imageSources={imageSources}
      onClick={onClick}
      onHover={onHover}
      skipMetadata={skipMetadata}
      replacePath={replacePath}
    />
  );
};
